<template>
    <div class="interior-view__body">
        <div class="interior-details">
            <span v-html="portfolio.content"></span>
            <div class="interior-details__rows">
                <div v-for="(space, index) in portfolio.spaces" :key="index" class="interior-details__row">
                    <div v-if="!space.beforeEnable" class="interior-details__content">
                        <p class="interior-details__description" v-html="space.content"></p>
                        <img v-if="space.afterImage" class="interior-details__content-image" :src="space.afterImage" />
                        <ul class="interior-list__tags">
                            <li v-for="tag in space.tags" :key="tag" class="interior-list__tag">#{{ tag }}</li>
                        </ul>
                    </div>

                    <div v-else class="interior-details__content" style="display:block;">
                        <p class="interior-details__description" v-html="space.content"></p>
                        <div class="compare-grid__images">
                            <div class="compare-slide">
                                <!-- 썸네일: Before -->
                                <div class="image">
                                    <img v-if="space.afterImage" class="thumb" :src="space.afterImage" alt="" />
                                </div>
                                <!-- 썸네일: After -->
                                <div class="image image-overlay2">
                                    <img v-if="space.beforeImage" class="thumb" :src="space.beforeImage" alt="" />
                                </div>
                            </div>
                        </div>
                        <ul class="interior-list__tags">
                            <li class="interior-list__tag" v-for="tag in space.tags" :key="tag">#{{ tag }}</li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        portfolio: { type: Object, default: null },
    },
    data() {
        return {
            component: null,
            isApplied: false,
        };
    },
    mounted() {
        this.component = this;
        this.init();
    },
    methods: {
        init: function() {
            function setImages() {
                const contents = document.querySelectorAll(".interior-details__content-image");
                if (window.innerWidth > 1200) {
                    contents.forEach(function(element) {
                        let img = element.clientWidth;
                        if (img) element.parentNode.style.maxWidth = img + "px";
                    });
                }

                const slides = document.querySelectorAll(".compare-slide");
                for (const slide of slides) {
                    const width = slide.clientWidth;
                    const images = slide.querySelectorAll("img.thumb");
                    for (const image of images) {
                        image.style.width = width + "px";
                    }
                }
            }
            window.addEventListener("load", setImages, false);
            setImages();
            this.$nextTick(() => {
                if (!this.isApplied) {
                    this.compareSlider();
                    this.isApplied = true;
                }
            });
        },
        compareSlider() {
            var items, i;
            // items.style.opacity = "0.5";
            try {
                items = document.querySelectorAll(".image-overlay2");
                for (const item of items) {
                    compareImage(item);
                }
            } catch (error) {
                console.error(error);
            }
            function compareImage(img) {
                var slider,
                    img,
                    clicked = 0,
                    w,
                    h;

                w = img.offsetWidth;
                h = img.offsetHeight;

                img.style.width = w / 2 + "px";

                slider = document.createElement("DIV");
                slider.setAttribute("class", "controller");

                img.parentElement.insertBefore(slider, img);

                slider.style.left = w / 2 - slider.offsetWidth / 2 + "px";

                slider.addEventListener("mousedown", slideReady);
                window.addEventListener("mouseup", slideFinish);
                slider.addEventListener("touchstart", slideReady, { passive: true });
                window.addEventListener("touchend", slideFinish);

                function slideReady(e) {
                    // e.preventDefault();
                    clicked = 1;

                    window.addEventListener("mousemove", slideMove);
                    window.addEventListener("touchmove", slideMove);
                }
                function slideFinish() {
                    clicked = 0;
                }
                function slideMove(e) {
                    var pos;

                    if (clicked == 0) return false;

                    pos = getCursorPos(e);

                    if (pos < 0) pos = 0;
                    if (pos > w) pos = w;

                    slide(pos);
                }
                function getCursorPos(e) {
                    var a,
                        x = 0;
                    e = e || window.event;
                    a = img.getBoundingClientRect();

                    if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
                        var touchX = 0;
                        for (i = 0; i < e.changedTouches.length; i++) {
                            touchX = e.changedTouches[i].pageX - a.left;
                            touchX = touchX - window.pageXOffset;
                        }
                        return touchX;
                    } else {
                        x = e.pageX - a.left;
                        x = x - window.pageXOffset;
                        return x;
                    }
                }
                function slide(x) {
                    img.style.width = x + "px";
                    slider.style.left = img.offsetWidth - slider.offsetWidth / 2 + "px";
                }
            }
        },
    },
    watch: {
        portfolio() {
            this.init();
        },
    },
};
</script>

<style lang="scss" scoped>
.image .thumb {
    position: absolute;
    height: initial;
}
</style>
